import { Routes, RouterModule } from "@angular/router";
import { NgModule } from "@angular/core";
import { CustomLayoutComponent } from "../layout/custom-layout/custom-layout.component";
import { ServiceItaComponent } from "./service-ita.component";

const routes: Routes = [
    {
        path: 'service-ita/:idtipologia', // Attenzione qui arriva direttamente l'id tipologia, non la linea prodotto
        component: CustomLayoutComponent,
        children: [
            { path: '', component: ServiceItaComponent },
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class ServiceItaRouter { }
